import React from 'react';
import { MapPin, Phone, Mail } from 'lucide-react';

const AboutPage = () => {
  return (
    <div className="paper-texture">
      {/* Hero */}
      <section
        className="hero-section flex items-center justify-center relative overflow-hidden"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1633383568437-8df892d90c90?w=1920&h=600&fit=crop)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="absolute inset-0 bg-deep-berry/70"></div>
        <div className="relative z-10 text-center text-white max-w-4xl px-6">
          <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl mb-6 text-white">
            Our Story
          </h1>
          <p className="text-lg sm:text-xl leading-relaxed max-w-2xl mx-auto">
            Preserving Cape Cod traditions, one jar at a time
          </p>
        </div>
      </section>

      {/* About Content */}
      <section className="py-24">
        <div className="max-w-4xl mx-auto px-6">
          <div className="prose prose-lg max-w-none">
            <h2 className="font-display text-4xl mb-6">Small Batch Excellence</h2>
            <p className="text-lg text-[#2D2A26] leading-relaxed mb-6">
              At Preserves of Cape Cod, we believe that the best preserves come from dedication to craft and quality ingredients. Our small-batch process ensures that every jar receives the attention it deserves, resulting in preserves that capture the true essence of fruit at its peak.
            </p>
            <p className="text-lg text-[#2D2A26] leading-relaxed mb-6">
              Located in the heart of Osterville, Massachusetts, we draw inspiration from the natural beauty and bounty of Cape Cod. Our commitment to traditional methods combined with careful ingredient selection has made us a beloved choice for both locals and visitors seeking authentic artisan preserves.
            </p>

            <h2 className="font-display text-4xl mb-6 mt-16">Our Process</h2>
            <p className="text-lg text-[#2D2A26] leading-relaxed mb-6">
              Every batch of our jams, jellies, marmalades, and preserves is carefully crafted using time-honored techniques that have been passed down through generations. We select only the finest fruits and ingredients, ensuring that each jar delivers exceptional flavor and quality.
            </p>
            <p className="text-lg text-[#2D2A26] leading-relaxed mb-6">
              Our unique small-batch process allows us to maintain strict quality control and create products that truly stand out. From classic favorites like Wild Beach Plum Jam to innovative combinations like Cranberry Pomegranate Jelly, each preserve tells a story of craftsmanship and care.
            </p>

            <h2 className="font-display text-4xl mb-6 mt-16">Available Locally</h2>
            <p className="text-lg text-[#2D2A26] leading-relaxed mb-6">
              You can find our products at select retail stores and gift shops throughout Cape Cod. If you don't see them at your favorite store, ask them to stock Preserves of Cape Cod – we're always happy to partner with new retailers who appreciate quality artisan products.
            </p>
          </div>
        </div>
      </section>

      {/* Location */}
      <section className="py-24 bg-alt-bg">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="font-display text-4xl text-center mb-12">Visit Us</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-8 text-center soft-shadow">
              <MapPin className="w-12 h-12 text-cape-red mx-auto mb-4" />
              <h3 className="font-display text-xl mb-3">Location</h3>
              <p className="text-[#5C5855]">
                45 Seth Goodspeed Way<br />
                Osterville, MA 02655
              </p>
            </div>
            <div className="bg-white p-8 text-center soft-shadow">
              <Phone className="w-12 h-12 text-cape-red mx-auto mb-4" />
              <h3 className="font-display text-xl mb-3">Hours</h3>
              <p className="text-[#5C5855]">
                Monday - Friday<br />
                9:00 AM - 5:00 PM<br />
                <span className="text-sm">Closed weekends</span>
              </p>
            </div>
            <div className="bg-white p-8 text-center soft-shadow">
              <Mail className="w-12 h-12 text-cape-red mx-auto mb-4" />
              <h3 className="font-display text-xl mb-3">Contact</h3>
              <p className="text-[#5C5855]">
                <a href="mailto:contactus@preservesofcapecod.com" className="hover:text-cape-red transition-colors">
                  contactus@preservesofcapecod.com
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
